var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',[_c('nav-bar')],1),_c('div',[_c('el-row',[_c('el-col',{attrs:{"span":_vm.layout.span,"offset":_vm.layout.offset}},[_c('div',{staticClass:"mt-4"},[_c('el-card',{staticClass:"box-card"},[_c('router-view')],1)],1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }